import algoliasearch from 'algoliasearch';

export const searchClient = algoliasearch(
  'MG6FMAIUPF',
  'ed360c2fe013c9df39b625c5d746758f'
);

// Parcel inlines `process.env.ALGOLIA_INDEX` at build time when it's
// referenced as a full literal expression like this. Defaults to the
// production index when the var isn't set (local dev, prod builds).
export const BASE_INDEX = process.env.ALGOLIA_INDEX ?? 'PRODUCTS';

export const products = searchClient.initIndex(BASE_INDEX);
export const misc = searchClient.initIndex('MISC');

export const indexesBySorting = {
  'price-per-unit-asc': BASE_INDEX,
  'price-per-item-asc': `${BASE_INDEX}_price-per-item_ASC`,
};
